import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import ReportIssueButton from './components/common/ReportIssueButton';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import SsoCallbackPage from './pages/SsoCallbackPage';
import DashboardPage from './pages/DashboardPage';
import MembersPage from './pages/MembersPage';
import PaymentsPage from './pages/PaymentsPage';
import DeceasedPage from './pages/DeceasedPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ContributionsOverviewPage from './pages/ContributionsOverviewPage';
import MemberProfilePage from './pages/MemberProfilePage';
import NotesPage from './pages/NotesPage';
import OverduePage from './pages/OverduePage';
import AuditLogPage from './pages/AuditLogPage';
import ReportedIssuesPage from './pages/ReportedIssuesPage';
import UsersPage from './pages/UsersPage';

function AppRoutes() {
  const { isAuthenticated, loading, loginWithToken } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900 flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/sso-callback" element={<SsoCallbackPage onToken={loginWithToken} />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <ReportIssueButton />
      <Routes>
        <Route path="/"                       element={<DashboardPage />} />
        <Route path="/contributions-overview" element={<ContributionsOverviewPage />} />
        <Route path="/members"                element={<MembersPage />} />
        <Route path="/members/:id"            element={<MemberProfilePage />} />
        <Route path="/payments"               element={<PaymentsPage />} />
        <Route path="/deceased"               element={<DeceasedPage />} />
        <Route path="/notes"                  element={<NotesPage />} />
        <Route path="/overdue"                element={<OverduePage />} />
        <Route path="/analytics"              element={<AnalyticsPage />} />
        <Route path="/audit-log"              element={<AuditLogPage />} />
        <Route path="/reported-issues"        element={<ReportedIssuesPage />} />
        <Route path="/users"                  element={<UsersPage />} />
        <Route path="*"                       element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
